import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Card } from '@chakra-ui/react'
import { AgGridReact } from 'ag-grid-react'

const SiteProjectsDetail = (props: any) => {

    const colDefs = [
        { headerName: "Name", field: "name", flex: 2 },
        { headerName: "Type", field: "type" },
        { headerName: "Model", field: "model" },  
        { headerName: "Manufacturer", field: "manufacturer" }
    ];

    return (

        <Card>
            <div
                className="ag-theme-quartz" // applying the grid theme
                style={{ height: 350 }} // the grid will fill the size of the parent container
            >
                <AgGridReact
                    rowData={props.AssetStore.siteAssets}
                    pagination
                    columnDefs={colDefs}
                    paginationAutoPageSize
                />
            </div>
        </Card>
    )
}

SiteProjectsDetail.propTypes = {
    AssetStore: PropTypes.any,
}

export default SiteProjectsDetail